import * as React from 'react';
import Icon from '../../../../banner/partials/Icon';
import { safeHref } from '../../helper';

export default function (props) {
  const { links } = props;

  if (Array.isArray(links) === false || links.length === 0) { return null; }

  return (
    <div className='links'>
      {links.map(entry => {
        const {provider, rawURL} = entry;
        return (
          <Icon key={rawURL} url={safeHref(rawURL)} platform={provider} target='_blank'/>
        );
      })}
    </div>
  );
}

export function Link({url, text}) {
  const href = safeHref(url);
  if (!href) {
    return null;
  }

  return (
    <a href={href} className='nv-cta-secondary nv-cta-secondary--small'>
      {text}
    </a>
  );
}
